import React, { ReactNode, useEffect } from 'react';

export interface AlertProps {
    index: number;
    message: ReactNode;
    type: string;
    dismissible?: boolean;
    timeout?: number;
    onDismiss?: () => void;
}

const Alert: React.FC<AlertProps> = ({ message, type, dismissible, index, timeout, onDismiss }) => {
    useEffect(() => {
        if (timeout && onDismiss) {
            window.setTimeout(onDismiss, timeout * 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={`alert alert-${type} alert--${index}${dismissible ? ' alert-dismissible' : ''}`}>
            {dismissible && (
                <a className='close' type='button' onClick={onDismiss}>
                    &times;
                </a>
            )}
            <div className='alert-message'>{message}</div>
        </div>
    );
};

export default React.memo(Alert);
